var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-home"},[_c('span',{on:{"click":_vm.backHome}},[_vm._v(_vm._s(_vm.lang === 'zh' ? '返回首页' : 'Back Home'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }